import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';
import styled from 'styled-components';
import { Flex, Text, Box } from 'atoms';

const StatusBarContainer = styled(Box)`
	padding: 12px 16px;
	background: #ffffff;
	border: 1px solid #bfceff;
	border-radius: 4px;
	margin-bottom: 16px;
	margin-top: 16px;
`;

const StatusItem = styled(Flex)`
	align-items: center;
	gap: 8px;
`;

const StatusLabel = styled(Text)`
	font-size: 14px;
	color: #595959;
	font-weight: 400;
`;

const StatusCount = styled(Text)`
	font-size: 14px;
	font-weight: 500;
`;

const Separator = styled.div`
	width: 1px;
	height: 20px;
	background: #d9d9d9;
	margin: 0 16px;
`;

const ToggleContainer = styled(Flex)`
	align-items: center;
	gap: 8px;
	margin-left: auto;
`;

function StatusFilterBar({ markedCount, unmarkedCount, unmarkedOnly, onToggle }) {
	return (
		<StatusBarContainer>
			<Flex alignItems="center" justifyContent="space-between">
				<Flex alignItems="center">
					<StatusItem>
						<StatusLabel>Marked</StatusLabel>
						<StatusCount style={{ color: '#52c41a' }}>{markedCount || 0}</StatusCount>
					</StatusItem>
					<Separator />
					<StatusItem>
						<StatusLabel>Unmarked</StatusLabel>
						<StatusCount style={{ color: '#fa8c16' }}>{unmarkedCount || 0}</StatusCount>
					</StatusItem>
				</Flex>
				<ToggleContainer>
					<StatusLabel>Unmarked Only</StatusLabel>
					<Switch checked={unmarkedOnly} onChange={onToggle} />
				</ToggleContainer>
			</Flex>
		</StatusBarContainer>
	);
}

StatusFilterBar.propTypes = {
	markedCount: PropTypes.number,
	unmarkedCount: PropTypes.number,
	unmarkedOnly: PropTypes.bool,
	onToggle: PropTypes.func.isRequired,
};

StatusFilterBar.defaultProps = {
	markedCount: 0,
	unmarkedCount: 0,
	unmarkedOnly: false,
};

export default StatusFilterBar;
